var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import LmsCourseResolverErrorDomainService from "../Domain/LmsCourseResolverError/LmsCourseResolverError.service";
const BASE_URL = "/aviso/lmsCourseResolverError";
export default class LmsCourseResolverErrorService {
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResults = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                courseDataQuery: search.courseDataQuery,
                messageQuery: search.messageQuery,
                createdDateFrom: search.createdDateFrom,
                createdDateTo: search.createdDateTo,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, searchResults), { data: searchResults.data.map(LmsCourseResolverErrorDomainService.fromJSON) });
        });
    }
}
